import React, { useState } from "react";
import Papa from "papaparse";
import generatePDFBase64 from './Utils/PdfGenerator';
import './App.css';

function App() {
    const [csvData, setCsvData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [extraInfo, setExtraInfo] = useState({});
    const [isDownloadingAll, setIsDownloadingAll] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const BATCH_SIZE = 10; // Number of PDFs to process at a time

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "text/csv") {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (result) => {
                    const allData = result.data;
                    const extra = {
                        row1: allData[0] || {},
                        row2: allData[1] || {},
                    };
                    setCsvData([]);
                    setHeaders([]);
                    setExtraInfo({});
                    const data = allData.slice(3);
                    setExtraInfo(extra);
                    setHeaders(Object.values(allData[2] || {}));
                    const updatedArray = updateKeys(data, Object.values(allData[2] || {}));
                    setCsvData(updatedArray);
                },
                error: (error) => {
                    console.error("Error parsing CSV:", error);
                },
            });
        } else {
            alert("Please upload a valid CSV file.");
        }
    };

    const updateKeys = (dataArray, headersArray) => {
        return dataArray.map(record => {
            const updatedRecord = {};
            headersArray.forEach((header, index) => {
                const key = index === 0 ? "Billing - AASLD" : index === 1 ? "" : `_${index - 1}`;
                updatedRecord[header] = record[key] || "";
            });
            return updatedRecord;
        });
    };

    const handleDownload = async (record, serialNo) => {
        const pdfData = {
            ...extraInfo,
            ...record,
        };

        const pdfBase64 = await generatePDFBase64(pdfData, extraInfo, serialNo);

        // Convert Base64 to Blob for downloading
        const pdfBlob = new Blob([Uint8Array.from(atob(pdfBase64), c => c.charCodeAt(0))], {
            type: "application/pdf",
        });

        // Create a link and download the PDF
        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = `${record.Name || "record"}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // **Batch Download PDFs to Prevent Freezing**
    const processBatch = async (startIndex) => {
        if (startIndex >= csvData.length) {
            setIsDownloadingAll(false);
            alert("All PDFs downloaded successfully!");
            return;
        }

        const batch = csvData.slice(startIndex, startIndex + BATCH_SIZE);
        const downloadPromises = batch.map((record, index) =>
            handleDownload(record, startIndex + index + 1)
        );

        await Promise.all(downloadPromises);
        
        // Update progress
        setDownloadProgress(Math.round(((startIndex + BATCH_SIZE) / csvData.length) * 100));

        // Process the next batch after a small delay to prevent UI freeze
        setTimeout(() => processBatch(startIndex + BATCH_SIZE), 500);
    };

    const handleDownloadAll = () => {
        if (csvData.length === 0) {
            alert("No data available to download.");
            return;
        }

        setIsDownloadingAll(true);
        setDownloadProgress(0);
        processBatch(0);
    };

    return (
        <div style={{ padding: "20px" }}>
            <h1>SOHAM Billing</h1>
            <input type="file" accept=".csv" onChange={handleFileChange} />
            {csvData.length > 0 && (
                <>
                    <table border="1" style={{ width: "100%", marginTop: "20px" }}>
                        <thead>
                            <tr>
                                {headers.map((header, index) => (
                                    <th key={index}>{header}</th>
                                ))}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {csvData.map((row, index) => (
                                <tr key={index}>
                                    {headers.map((header, index) => (
                                        <td key={index}>{row[header]}</td>
                                    ))}
                                    <td>
                                        <button
                                            onClick={() => handleDownload(row, index + 1)}
                                            style={{ padding: "5px 10px", cursor: "pointer" }}
                                        >
                                            Download
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    
                    {/* Download All Button */}
                    <button
                        onClick={handleDownloadAll}
                        disabled={isDownloadingAll}
                        style={{
                            marginTop: "20px",
                            padding: "10px 20px",
                            backgroundColor: isDownloadingAll ? "gray" : "#28a745",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        {isDownloadingAll ? `Downloading... ${downloadProgress}%` : "Download All PDFs"}
                    </button>
                </>
            )}
        </div>
    );
}

export default App;
